import React from 'react';
import * as Styled from "./styled";

const ProjectWork = ( {project} ) => {
  return (
    <Styled.ProjectCard>
      <Styled.ProjectInfo>
        <p>{project.title}</p>
        <p>Skill: {project.skill}</p>
        <p>Duration:  {project.duration}</p>
        {project.downloadLink && (
            <>
              <a href={project.downloadLink} className="download-link">Download Report</a>
              <div className="download-description">{project.downloadDescription}</div>
            </>
          )}
      </Styled.ProjectInfo>
      <div className="assessment-video">
        <video style={{ width: "100%", height: "auto", maxWidth: "100%" }} controls>
          <source src={project.videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </Styled.ProjectCard>
  );
};

export default ProjectWork;
